import get from 'lodash/get';
import axiosConfig from './axiosConfig';

const DOMAIN = 'spacer_log';

const unwrap = (res) => {
  const top = get(res, 'data', null);
  const nested = get(res, ['data', 'data'], null);
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) return nested;
  if (top && typeof top === 'object' && !Array.isArray(top)) return top;
  return null;
};

/**
 * Discover AI insight features + availability flags.
 * GET /pih/ai/insights/features?domain=spacer_log
 */
export const fetchAiInsightFeatures = async ({ domain = DOMAIN } = {}) => {
  const res = await axiosConfig.get('ai/insights/features', {
    params: { domain },
  });
  const data = unwrap(res);
  if (!data || typeof data !== 'object') {
    throw new Error('AI insights features response was empty or invalid.');
  }
  return {
    enabled: data.enabled !== false,
    provider: data.provider || null,
    bedrockModelId: data.bedrockModelId || null,
    ragConfigured: Boolean(data.ragConfigured),
    features: Array.isArray(data.features) ? data.features : [],
  };
};

/**
 * Generate an insight (AI or template). Supports AbortSignal for cancel.
 * POST /pih/ai/insights
 */
export const generateAiInsight = async (body, { signal } = {}) => {
  const payload = {
    domain: DOMAIN,
    ...body,
  };
  const res = await axiosConfig.post('ai/insights', payload, { signal });
  const data = unwrap(res);
  if (!data || typeof data !== 'object') {
    throw new Error('AI insight response was empty or invalid.');
  }
  return data;
};

export const AI_INSIGHTS_DOMAIN = DOMAIN;

/** Feature ids used by Spacer Log dashboard UI (Phase 1). */
export const SPACER_LOG_AI_FEATURES = {
  PERIOD_BRIEF: 'period_brief',
  SHIFT_BRIEF: 'shift_brief',
  BOTTLENECK_COACH: 'bottleneck_coach',
  COMMENT_THEMES: 'comment_themes',
  COMPLIANCE_ASSISTANT: 'compliance_assistant',
  ANOMALY_EXPLAIN: 'anomaly_explain',
  NL_QA: 'nl_qa',
  RAG_QA: 'rag_qa',
};

export const DAILY_AI_FEATURE_IDS = [
  SPACER_LOG_AI_FEATURES.SHIFT_BRIEF,
  SPACER_LOG_AI_FEATURES.BOTTLENECK_COACH,
  SPACER_LOG_AI_FEATURES.COMMENT_THEMES,
  SPACER_LOG_AI_FEATURES.COMPLIANCE_ASSISTANT,
  SPACER_LOG_AI_FEATURES.ANOMALY_EXPLAIN,
];

export const isAiInsightsUiEnabled = () => {
  const flag = process.env.REACT_APP_AI_INSIGHTS;
  if (flag == null || flag === '') return true;
  return flag === 'true' || flag === '1';
};
